import React, { useState } from 'react';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import config from "../../config";
import logoComplete from "../../assets/images/logo-copmpleto.png";

import BannerLogin from '../Authentication/BannerLogin';
import Rodape from '../Authentication/Rodape';

import { Row, Col, Card, CardBody, Form, Alert } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LOGIN } from '../../helpers/routes_helper';

const RecoverPassword = () => {
    document.title = "Defender | Esqueceu sua senha?"

    const [email, setEmail] = useState('');
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState('warning');
    const [messageVisible, setMessageVisible] = useState(false);
    const [cookies] = useCookies(['_csrf_token']);

    const handlePasswordReset = async (e) => {
        e.preventDefault();
        
        if (!email){
            setMessage('Por favor, insira um email válido.');
            setMessageType('warning');
            setMessageVisible(true);
            return;
        }

        try {
            const {data} = await axios.post(`${config.URL_SERVER}/execute-procedure`, {
                proc: 'FRONT_Usuario_Redefinir_Senha',
                requestData: { "email": email, "ip": ""}
            }, {
                headers: {
                    "X-CSRF-Token": cookies?._csrf_token
                }
            });
            
            const result = data?.data[0];

            if (result && result.statusCode === 200) {
                setMessage(result.message);                
                setMessageType('success');
            } else {
                setMessage(result.message); 
                setMessageType('warning');
            }
        } catch (error) {
            console.error("Erro ao enviar email:", error);
            setMessage('Erro ao enviar o email: ' + error);
            setMessageType('danger');
          } finally {
          setMessageVisible(true);
        }
    };

    return (
      <React.Fragment>
        <Row className="h-100 m-0">
          <Col lg={4} md={6} className="d-flex flex-column justify-content-between col-login">
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ flexGrow: 1 }}
            >
              <Card className="card-login h-100 w-100 p-30">
                <CardBody className="text-center d-flex flex-column ">
  
                  <div className="text-center align-content-center flex-grow-1">
                    <Link to="/">
                      <img
                        src={logoComplete}
                        alt=""
                        className="auth-logo mx-auto logo-login"
                      />
                    </Link>
                  </div>
  
                  <div className="flex-grow-1 flex-column d-flex">
                    <div className="d-flex flex-column">

                        <div className="font-size-10 d-grid mt-2 d-flex t-left">
                          <Link to={LOGIN} className="font-size-14 botao-voltar-login">
                            <i className="fas fa-arrow-left"> </i> voltar ao login?
                          </Link>
                        </div>

                        <h4 className="font-size-18 text-muted mt-2 bold-01">
                          Esqueceu sua senha?
                        </h4>
  
                        <Form
                          className="form-horizontal"
                          onSubmit={handlePasswordReset}
                        >
                          <div className="d-grid my-md-3 my-4">
                            <div className="input-group">
                              <div className="input-group-text input-icone-login">
                                <i className="fas fa-user azul-claro"></i>
                              </div>
                              <input
                                name="email"
                                type="email"
                                className="form-control input-login"
                                placeholder="usuario@empresa.com.br"
                                onChange={(e) => setEmail(e.target.value)}
                                value={email || ""}
                              />
                            </div>
                          </div>

                          {messageVisible && (
                            <Alert color={messageType}><div>{message}</div></Alert>
                          )}
  
                          <div className="d-grid mt-4">
                            {messageType !== 'success' && (
                              <button
                                className="btn btn-primary waves-effect waves-light"
                                type="submit"
                              >
                                ENVIAR
                              </button>
                            )}
                          </div>
                        </Form>
                        
                        <div className="font-size-14 d-grid pt-4 pt-md-5 d-flex align-items-center justify-content-center">
                            Precisa de ajuda? 
                            <Link to="/BI_AC0002" className="light-blue-01 fala-conosco">
                              Fale conosco.
                            </Link>
                          </div>
                      </div>
                  </div>
                </CardBody>
              </Card>
            </div>
  
            <div className="text-center p-3">
              <Rodape />
            </div>
          </Col>
  
          <Col
            className="d-flex align-items-center justify-content-center bg-dark col-login p-0"
          >
            <BannerLogin />
          </Col>
        </Row>
      </React.Fragment>
    );
}

export default RecoverPassword;